export enum PaymentTypeEnum {
    
    // Предоплата
	prepayment = 1,

	// Кредитная форма
	creditForm = 2,

	// Онлайн
	online = 6
}